import { useCallback } from 'react';
import { buildService } from '../service';
import serviceMethods from '../service_methods';
const api = buildService('/claim_project_reports/{id}/project_report_ai_transcript_statuses', {
  only: ['base', 'all', 'create']
});
const useFetchStatuses = _ref => {
  let {
    projectId,
    setLoading
  } = _ref;
  const [statuses, setStatuses, fetchStatuses] = serviceMethods.useFetch({
    callback: useCallback(async () => await api.all(projectId), [projectId]),
    setLoading
  });
  return [statuses, setStatuses, fetchStatuses];
};
const useFetchStatusWithInterval = _ref2 => {
  let {
    projectId,
    setLoading
  } = _ref2;
  const {
    interval,
    setInterval,
    stateVar: status,
    setStateVar: setStatus
  } = serviceMethods.useFetchWithInterval({
    api,
    callback: useCallback(async () => {
      const statuses = await api.all(projectId);
      return statuses[statuses.length - 1];
    }, [projectId]),
    setLoading
  });
  return {
    status,
    setStatus,
    interval,
    setInterval
  };
};
const useCreate = _ref3 => {
  let {
    projectId,
    setLoading,
    onSuccess,
    onError,
    onFinally
  } = _ref3;
  const createTranscript = serviceMethods.useCreate({
    setLoading,
    onSuccess,
    onError,
    onFinally,
    callback: useCallback(async () => {
      const transcriptGenerationStatus = await api.create(projectId);
      return transcriptGenerationStatus;
    }, [projectId])
  });
  return createTranscript;
};
export const projectReportAiTranscriptStatusesService = {
  // useCrud ({ projectId, setLoading }) {
  //   const [statuses, setStatuses, fetchStatuses] = useFetchStatuses({ projectId, setLoading })
  //   const { status, setStatus, interval, setInterval }
  //   return {
  //     statuses,
  //     setStatuses,
  //     fetchStatuses
  //   }
  // }

  useFetchStatuses,
  useFetchStatusWithInterval,
  useCreate
};